<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #c7faf6;">
          <h5 class="card-title">Entrega de Tramites</h5>

          <div class="row mb-3" style="margin: 0px 0px -10px 0px; padding: -10px;">
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Gestion: </label>
                  <select 
                    v-model="filters.gestion" 
                    class="form-select"
                  >
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <select 
                    v-model="filters.id_unidad" 
                    class="form-select" 
                    @change="(e) => { console.log('Cambió unidad:', e.target.value); fetchAreas() }"
                  >
                    <option value="">Todas las unidades</option>
                    <option 
                      v-for="unidad in unidades" 
                      :key="unidad.id" 
                      :value="unidad.id"
                    >
                      {{ unidad.nombre_unidad }} ({{ unidad.codigo }})
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <select 
                    v-model="filters.id_area" 
                    class="form-select"
                  >
                    <option value="">Todas las secciones</option>
                    <option 
                      v-for="area in areas" 
                      :key="area.id" 
                      :value="area.id"
                    >
                      ({{ area.codigo }}) {{ area.nombre_area }} 
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          
          <div class="row mb-3" style="margin: -20px 0px -10px 0px; padding: -10px;">
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Etapa: </label>
                  <select 
                    v-model="filters.etapa" 
                    class="form-select"
                  >
                    <option value="Todos">Todos</option>
                    <option value="Recepcion">Recepcion</option>
                    <option value="Evaluacion">Evaluacion</option>
                    <option value="Aprobacion">Aprobacion</option>
                    <option value="Entrega">Entrega</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Estado: </label>
                  <select 
                    v-model="filters.estado" 
                    class="form-select"
                  >
                    <option value="Todos">Todos</option>
                    <option value="Recibido">Recibido</option>
                    <option value="Entregado">Entregado</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Desde: </label>
                  <input
                    type="date"
                    v-model="filters.desde"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Hasta: </label>
                  <input
                    type="date"
                    v-model="filters.hasta"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3" style="margin: -20px 0px -10px 0px; padding: -10px;">
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Filtrar por: </label>
                  <select 
                    v-model="filters.bpor" 
                    class="form-select"
                  >
                    <option value="">-- Buscar Por --</option>
                    <option value="codigo">Codigo</option>
                    <option value="solicitante">Solicitante</option>
                    <option value="tipotramite">Tipo Tramite</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="filters.criterio"
                    class="form-control"
                    required
                  />
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>

              </div>
            </div>
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('tramite_create')"
                variant="danger"
                class="btn-round btn-sm"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>

        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                <thead class="text-primary">
                  <tr style="line-height: 8px;">
                    <th>Codigo</th>
                    <th>Tipo Tramite</th>
                    <th>Solicitate</th>
                    <th>Gestion</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tramite in tramites" :key="tramite.id">
                    <td>{{ tramite.codigo }}</td>
                    <td>{{ tramite.tipo_tramite }}</td>
                    <td>{{ tramite.nombres }} {{ tramite.paterno }} {{ tramite.materno }}</td>
                    <td>{{ tramite.gestion }}</td>
                    <td>
                      <BBadge :variant="tramite.entrega === 'Recibido' ? 'warning' : 'success'">
                        {{ tramite.entrega }}
                      </BBadge>
                    </td>
                    <td>{{ tramite.fecha_formateada_entrega }}</td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          variant="danger"
                          class="btn-round btn-sm"
                          @click="generateFormPDF(tramite.id)"
                        >
                          <i class="fa fa-file-pdf me-1"></i>
                        </BButton>
                        <router-link 
                          :to="`/tramite/detail/${tramite.id}`" 
                          class="btn btn-sm btn-success"
                        >
                          <i class="fa fa-folder-open"></i>
                        </router-link>
                        <BButton
                          v-if="!tramite.entrega || tramite.entrega === 'Recibido'"
                          @click="showModal(tramite)"
                          variant="primary"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-cog"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row mt-3">
          <label class="form-label col-md-2">Codigo:</label>
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="text"
                v-model="form.codigo"
                class="form-control"
                :class="{ 'is-invalid': errors.codigo }"
                required
                readonly
              />
              <div class="invalid-feedback" v-if="errors.codigo">
                {{ errors.codigo[0] }}
              </div>
            </div>
          </div>
          <label class="form-label col-md-2">Gestion:</label>
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="text"
                v-model="form.gestion"
                class="form-control"
                :class="{ 'is-invalid': errors.gestion }"
                readonly
                required
              />
              <div class="invalid-feedback" v-if="errors.gestion">
                {{ errors.gestion[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <label class="form-label col-md-2">Tipo Tramite:</label>
          <div class="col-md-10">
            <div class="form-group">
              <select
                v-model="form.id_tipo_tramite"
                class="form-select" 
                :class="{ 'is-invalid': errors.id_tipo_tramite }"
                disabled
              >
                <option value="">Seleccione tipo tramite</option>
                <option 
                  v-for="tipotramite in tipotramites" 
                  :key="tipotramite.id" 
                  :value="tipotramite.id"
                >
                  {{ tipotramite.tipo }}
                </option>
              </select>
                    
              <div v-if="errors.id_tipo_tramite" class="invalid-feedback">
                {{ errors.id_tipo_tramite[0] }}
              </div>
              <div v-if="loadingTipotramites" class="text-muted small">
                Cargando tipo de tramites...
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <label class="form-label col-md-2">Solicitado Por:</label>
          <div class="col-md-10">
            <div class="form-group">
              <select 
                class="form-select" 
                v-model="form.id_solicitante" 
                disabled
                :class="{ 'is-invalid': errors.id_solicitante }"
              >
                <option value="">Seleccione Solicitante</option>
                <option 
                  v-for="persona in personas" 
                  :key="persona.id" 
                  :value="persona.id"
                >
                  {{ persona.nombres }} {{ persona.paterno }} {{ persona.materno }}
                </option>
              </select>
                    
              <div v-if="errors.id_solicitante" class="invalid-feedback">
                {{ errors.id_solicitante[0] }}
              </div>
              <div v-if="loadingPersonas" class="text-muted small">
                Cargando personas...
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <label class="form-label col-md-2">Entregar:</label>
          <div class="col-md-4">
            <div class="form-group">
              <select 
                class="form-select" 
                v-model="form.entrega_tipo"
              >
                <option value="1">El Mismo</option>
                <option value="2">Familiar</option>
                <option value="3">Terceros</option>
              </select>
              <div v-if="errors.entrega_tipo" class="invalid-feedback">
                {{ errors.entrega_tipo[0] }}
              </div>
            </div>
            
          </div>
          <label class="form-label col-md-2" v-if="form.entrega_tipo=='3'">Nro Poder:</label>
          <div class="col-md-4" v-if="form.entrega_tipo=='3'">
            <div class="form-group">
              <input
                type="text"
                v-model="form.nro_poder"
                class="form-control"
                :class="{ 'is-invalid': errors.nro_poder }"
              />
              <div v-if="errors.nro_poder" class="invalid-feedback">
                {{ errors.nro_poder[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <label class="form-label col-md-2">Entregado a:</label>
          <div class="col-md-10">
            <div class="form-group">
              <!-- Buscador por CI -->
              <div class="input-group mb-3">
                <input
                  type="text"
                  v-model="ciSearch"
                  class="form-control"
                  placeholder="Buscar por Número de CI"
                  @input="searchByCI"
                />
                <button 
                  class="btn btn-outline-secondary" 
                  type="button"
                  @click="searchByCI"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>

              <!-- Resultados de la búsqueda -->
              <div v-if="searchResults.length > 0" class="search-results">
                <div 
                  v-for="persona in searchResults" 
                  :key="persona.id"
                  class="search-result-item"
                  :class="{ 'selected': form.id_entregadoa === persona.id }"
                  @click="selectPersona(persona)"
                >
                  {{ persona.nombres }} {{ persona.paterno }} {{ persona.materno }} - CI: {{ persona.carnet_identidad }}
                </div>
              </div>

              <!-- Mostrar persona seleccionada -->
              <div v-if="form.id_entregadoa && selectedPersona" class="selected-persona">
                <strong>Seleccionado:</strong> 
                {{ selectedPersona.nombres }} {{ selectedPersona.paterno }} {{ selectedPersona.materno }} 
                (CI: {{ selectedPersona.carnet_identidad }})
              </div>

              <div v-if="errors.id_entregadoa" class="invalid-feedback">
                {{ errors.id_entregadoa[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Guardar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Tramite {
  id: number;
  id_tipo_tramite: number;
  id_solicitante: number;
  gestion: number;
  codigo: string;
}

interface FormData {
  id: number | null;
  id_tipo_tramite: number;
  id_solicitante: number;
  gestion: number;
  entrega_tipo: number;
  nro_poder: string;
  codigo: string;
}

interface Filters {
  id_unidad: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const tramites = ref<Tramite[]>([]);
    const loading = ref(true);
    const unidades = ref<Unidad|[]>([]);
    const loadingUnidades = ref(true);
    const areas = ref<Area|[]>([]);
    const loadingAreas = ref(true);
    const tipotramites = ref<Tipotramite[]>([]);
    const loadingTipotramites = ref(true);
    const personas = ref<Persona[]>([]);
    const loadingPersonas = ref(true);
    const authStore = useAuthStore();
    const filters = ref<Filters>({
      id_unidad: '',
      id_area: '',
      bpor: '',
      criterio: '',
      gestion: ref(new Date().getFullYear()),
      etapa: 'Entrega',
      estado: 'Recibido',
      desde: '',
      hasta: ''
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});

    // Nuevas variables para el buscador por CI
    const ciSearch = ref('');
    const searchResults = ref<Persona[]>([]);
    const selectedPersona = ref<Persona | null>(null);
    const searching = ref(false);


    const form = ref<FormData>({
      id: null,
      id_tipo_tramite: '',
      id_solicitante: '',
      gestion: ref(new Date().getFullYear()),
      codigo: '',
      entrega: 'Entregado',
      entrega_tipo: 1,
      nro_poder: '',
      observacion: '',
      id_entregadoa: '',
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Procesar Tramite' : 'Tramite';
    });

    // Método para buscar personas por CI
    const searchByCI = async () => {
      if (!ciSearch.value.trim()) {
        searchResults.value = [];
        return;
      }

      searching.value = true;
      try {
        const response = await axios.get('/persona/search', {
          params: { ci: ciSearch.value }
        });
        searchResults.value = response.data.personas || [];
      } catch (error) {
        console.error('Error al buscar personas:', error);
        searchResults.value = [];
      } finally {
        searching.value = false;
      }
    };

    // Método para seleccionar una persona de los resultados
    const selectPersona = (persona: Persona) => {
      form.value.id_entregadoa = persona.id;
      selectedPersona.value = persona;
      searchResults.value = [];
      ciSearch.value = '';
    };

    const showModal = (tramite: Tramite | null) => {
      errors.value = {};
      if (tramite) {
        // Edición
        isEditing.value = true;
        form.value = {
          id: tramite.id,
          codigo: tramite.codigo,
          id_tipo_tramite: tramite.id_tipo_tramite,
          id_solicitante: tramite.id_solicitante,
          gestion: tramite.gestion,
          entrega: 'entregado',
          entrega_tipo: 1,
          nro_poder: tramite.nro_poder,
          id_entregadoa: tramite.id_entregadoa
        };
      }else{
        form.value = {
          id: tramite.id,
          codigo: tramite.codigo,
          id_tipo_tramite: tramite.id_tipo_tramite,
          id_solicitante: tramite.id_solicitante,
          gestion: tramite.gestion,
          entrega: '',
          entrega_tipo: 1,
          nro_poder: '',
          id_entregadoa: ''
        }
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      try {
        let response;
        
        if (isEditing.value && form.value.id) {
          response = await axios.post(`/procesamiento/entrega/${form.value.id}`, form.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        modalVisible.value = false;
        fetchTramite();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };
    const fetchUnidades = async () => {
      try {
        const response = await axios.get('/unidad/select');
        unidades.value = response.data.unidades;
      } catch (error) {
        console.error('Error al cargar unidades:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las unidades organizacionales'
        });
      } finally {
        loadingUnidades.value = false;
      }
    };

    const fetchAreas = async () => {
      console.log('Iniciando fetchAreas, id_unidad:', filters.value.id_unidad);
      if (!filters.value.id_unidad) {
        areas.value = []; // Limpiar áreas si no hay unidad seleccionada
        filters.id_area = ''; // Resetear el área seleccionada
        return;
      }

      loadingAreas.value = true;
      try {
        const response = await axios.get('/area/select', {
          params: { id_unidad: filters.value.id_unidad }
        });
        areas.value = response.data.areas || [];
      } catch (error) {
        console.error('Error al cargar secciones:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las secciones funcionales'
        });
      } finally {
        loadingAreas.value = false;
      }
    };

    const fetchTipotramites = async () => {
      try {
        const response = await axios.get('/tipotramite/select');
        tipotramites.value = response.data.tipotramites;
      } catch (error) {
        console.error('Error al cargar tipos de tramites:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los tipos de tramites'
        });
      } finally {
        loadingTipotramites.value = false;
      }
    };

    const fetchPersonas = async () => {
      loadingPersonas.value = true;
      try {
        const response = await axios.get('/persona/select');
        personas.value = response.data.personas || [];
      } catch (error) {
        console.error('Error al cargar personas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las personas'
        });
      } finally {
        loadingPersonas.value = false;
      }
    };

    const fetchTramite = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        
        if (filters.value.id_unidad) {
          params.id_unidad = filters.value.id_unidad;
        }
        if (filters.value.id_area) {
          params.id_area = filters.value.id_area;
        }
        if (filters.value.bpor) {
          params.bpor = filters.value.bpor;
        }
        if (filters.value.criterio) {
          params.criterio = filters.value.criterio;
        }
        if (filters.value.gestion) {
          params.gestion = filters.value.gestion;
        }
        if (filters.value.etapa) {
          params.etapa = filters.value.etapa;
        }
        if (filters.value.estado) {
          params.estado = filters.value.estado;
        }
        if (filters.value.desde) {
          params.desde = filters.value.desde;
        }
        if (filters.value.hasta) {
          params.hasta = filters.value.hasta;
        }

        const response = await axios.get('/tramite/list', { params });
        tramites.value = response.data.tramites.data || response.data.tramites;
        
        // Actualizar paginación si la API la soporta
        if (response.data.tramites.meta) {
          pagination.value = {
            current_page: response.data.tramites.meta.current_page,
            per_page: response.data.tramites.meta.per_page,
            total: response.data.tramites.meta.total,
            last_page: response.data.tramites.meta.last_page
          };
        }
        
      } catch (error) {
        console.error('Error al cargar tramites:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los tramites'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchTramite();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchTramite();
    };
    
    const confirmDelete = (tramite: Tramite) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la sección ${tramite.codigo}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteTramite(tramite.id);
        }
      });
    };
    
    const deleteTramite = async (id: number) => {
      try {
        await axios.delete(`/tramite/delete/${id}`);
        Swal.fire({
          icon: 'success',
          title: 'Sección eliminada',
          text: 'La sección ha sido eliminada correctamente'
        });
        await fetchTramite();
      } catch (error: any) {
        console.error('Error al eliminar sección:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar la sección'
        });
      }
    };

    const generatePDF = () => {
      // Lógica para generar PDF
      //const params = filters.value.id_unidad ? { id_unidad: filters.value.id_unidad } : {};
      const params = {
        ...(filters.value.id_unidad && { id_unidad: filters.value.id_unidad }),
        ...(filters.value.id_area && { id_area: filters.value.id_area }),
        ...(filters.value.bpor && { bpor: filters.value.bpor }),
        ...(filters.value.criterio && { criterio: filters.value.criterio }),
        ...(filters.value.gestion && { gestion: filters.value.gestion }),
        ...(filters.value.etapa && { etapa: filters.value.etapa }),
        ...(filters.value.estado && { estado: filters.value.estado }),
        ...(filters.value.desde && { desde: filters.value.desde }),
        ...(filters.value.hasta && { hasta: filters.value.hasta }),
      };
      axios.get('/tramite/reporteTramite', {
        params,
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-tramites.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const generateFormPDF = (id: number) => {
      axios.get(`/tramite/reporte/${id}`, {
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `tramite_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };

    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchTramite();
      fetchUnidades();
      fetchTipotramites();
      fetchPersonas();
    });
    
    return {
      tramites,
      unidades,
      loadingUnidades,
      tipotramites,
      loadingTipotramites,
      personas,
      fetchPersonas,
      loadingPersonas,
      areas,
      fetchAreas,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF,
      generateFormPDF,
      ciSearch,
      searchResults,
      selectedPersona,
      searching,
      searchByCI,
      selectPersona
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
</style>